import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { BattleRoyaleIndex } from './index';
import { PlayerRegistration } from './player/PlayerRegistration';
import { TutorialScreen } from './player/TutorialScreen';
import { GameScreen } from './player/GameScreen';
import { GroupRanking } from './screen/GroupRanking';
import { IndividualRanking } from './screen/IndividualRanking';
import { UnifiedScreen } from './screen/UnifiedScreen';
import { MasterDashboard } from './master/MasterDashboard';
import { CreateSession } from './master/CreateSession';
import { SessionSettings } from './master/SessionSettings';

export const BattleRoyaleRouter: React.FC = () => {
  return (
    <Routes>
      {/* マスター管理ルート */}
      <Route path="master">
        <Route index element={<CreateSession />} />
        <Route path=":sessionId" element={<MasterDashboard />} />
        <Route path=":sessionId/settings" element={<SessionSettings />} />
      </Route>

      {/* プレイヤー向けルート */}
      <Route path="player">
        <Route path="register" element={<PlayerRegistration />} />
        <Route path=":sessionId">
          <Route index element={<PlayerRegistration />} />
          <Route path="tutorial" element={<TutorialScreen />} />
          <Route path="game" element={<GameScreen />} />
        </Route>
      </Route>

      {/* スクリーン表示ルート */}
      <Route path="screen">
        <Route path=":sessionId">
          <Route index element={<UnifiedScreen />} />
          <Route path="group" element={<GroupRanking />} />
          <Route path="individual" element={<IndividualRanking />} />
        </Route>
      </Route>

      {/* 旧URLからのリダイレクト */}
      <Route path=":sessionId/player/tutorial" element={<Navigate to={`/battle-royale/player/:sessionId/tutorial`} replace />} />
      
      {/* ルートパス - トップページ */}
      <Route index element={<BattleRoyaleIndex />} />
    </Routes>
  );
};